import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

/**
 * Page shown after a tenant admin completes the Microsoft admin consent flow.
 * Microsoft redirects here with tenant_id etc.; we just show success.
 * Users in that org can now connect Office 365 without seeing "Approval required".
 */
const Office365AdminConsentCallback: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
        <Typography variant="h5" gutterBottom color="success.main">
          Admin consent granted
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Users in your organization can now connect Office 365 without seeing an approval screen.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
          You can close this tab.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Office365AdminConsentCallback;
